import { createFileRoute } from '@tanstack/react-router'

import { LeaveBalancesPage } from '@/features/leave/pages/LeaveBalancesPage'

export const Route = createFileRoute('/_authenticated/leave/config/balances')({
  component: LeaveBalancesPage,
})
